/**
 * @component JointCertProgramInstallComponent
 * @title 공동인증서 보안 프로그램 설치 안내
 * @description [securityLevel:5]메뉴 진입 시 보안 프로그램 설치 여부 판단 후 미설치 시 노출 팝업
 *              publish 파일명 : CRTJCT000_02FP
 * @author 2034264
 * @history
 * 2026-07-21 최초 작성
 */
import { useTranslation } from 'react-i18next';
import { useMenuRouter } from 'scbk-services';
import { BulletList, BulletListItem, DialogWrapper } from 'scbk-ui-web';
import { useProgramInstall } from '../hooks/useProgramInstall';

export const JointCertProgramInstallComponent: React.FC<ReturnType<typeof useProgramInstall>> = ({
  popup,
}) => {
  const { goMenu } = useMenuRouter();
  const { t } = useTranslation();

  return (
    <DialogWrapper
      open={popup.isOpen}
      setOpen={popup.setOpen}
      onClose={() => {
        popup.close();
        goMenu('CRTJCT000');
      }}
      title={t('JoinCertProgramInstallComponent.001', '보안프로그램 설치 안내')}
      isFull
      footer={[
        {
          type: 'primary',
          title: t('JoinCertProgramInstallComponent.002', '보안 프로그램 설치'),
          handler: () => {
            goMenu('COMETC000');
          },
          hasClose: true,
        },
      ]}
    >
      <div>
        <h2 className="page-heading-title mb-3">
          {t('JoinCertProgramInstallComponent.011', '공동인증서 보안 프로그램 설치 안내')}
        </h2>
        <p className="page-desc-lg">
          {t(
            'JoinCertProgramInstallComponent.003',
            '안전한 금융거래를 위해 보안 프로그램 설치가 필요해요.',
          )}
          <br />
          {t(
            'JoinCertProgramInstallComponent.004',
            '설치하지 않으면 일부 서비스 이용에 제한이 있어요. 설치 후 이용해 주세요.',
          )}
        </p>
        <div className="mt-8">
          <BulletList type="circle" size="medium">
            <BulletListItem>
              {t('JoinCertProgramInstallComponent.008', '저장된 공동인증서가 보이지 않는 경우')}
            </BulletListItem>
            <BulletListItem>
              {t(
                'JoinCertProgramInstallComponent.009',
                'PC나 USB 등 저장된 공동인증서를 이용하는 경우',
              )}
            </BulletListItem>
            <BulletListItem>
              {t(
                'JoinCertProgramInstallComponent.005',
                '다른 기관에서 발급한 인증서 등록이 필요한 경우',
              )}
            </BulletListItem>
            <BulletListItem>
              {t(
                'JoinCertProgramInstallComponent.006',
                '인증서 복사가 필요한 경우 (가져오기/내보내기)',
              )}
            </BulletListItem>
            <BulletListItem>
              {t('JoinCertProgramInstallComponent.010', '공동인증서를 갱신하는 경우')}
            </BulletListItem>
            <BulletListItem>
              {t('JoinCertProgramInstallComponent.007', '인증서 효력정지/효력회복이 필요한 경우')}
            </BulletListItem>
          </BulletList>
        </div>
      </div>
    </DialogWrapper>
  );
};
